<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { GetadminsetList } from "@/setAxios.js";
export default {
  data() {
    return {
      transitionName: "",
    };
  },
  name: "App",
  async created() {
    this.copyVuex();

    if (!this.$store.state.adminSetting.isHave) {
      let res = await GetadminsetList();
      if (res.Data) {
        this.$store.state.adminSetting.isHave = true;
        if (res.Data.adst05) {
          this.$store.state.adminSetting.adst05 =
            this.$store.state.baseUrl + res.Data.adst05;
        }
        if (res.Data.adst03) {
          this.$store.state.adminSetting.adst03 = res.Data.adst03;
        }
        if (res.Data.adst04) {
          this.$store.state.adminSetting.ptbaArr = JSON.parse(res.Data.adst04);
        }
        if (res.Data.adst06) {
          this.$store.state.adminSetting.adst06 =
            this.$store.state.baseUrl + res.Data.adst06;
        }
      }
    }
    if (this.$store.state.adminSetting.adst03 != "") {
      document.title = this.$store.state.adminSetting.adst03;
    }
    // if (this.$store.state.adminSetting.adst05 != "") {
    //   var link = document.querySelector('link[rel*="icon"]');
    //   link.href = this.$store.state.adminSetting.adst05;
    // }
    if (!window.location.href.includes("https")) {
      this.$store.state.baseUrl = this.$store.state.baseUrl2;
      localStorage.url = this.$store.state.baseUrl;
    }
  },
  methods: {},
  mounted() { },
  beforeDestroy() { },
};
</script>
<style lang="less">
/* 清除 Chrome、Safari、Edge 等 Webkit 内核浏览器的 spin 按钮 */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* 移除默认样式 */
  margin: 0;
  /* 清除边距，避免布局偏移 */
}

/* 清除 Firefox 浏览器的 spin 按钮 */
input[type="number"] {
  -moz-appearance: textfield;
  /* 强制将数字输入框渲染为普通文本框样式 */
}


.tabBtn {
  width: 160px;
  height: 40px;
  background-image: url("./assets/img/A三期/2.png");
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.tabBtnActive {
  width: 160px;
  height: 40px;
  background-image: url("./assets/img/A三期/1.png");
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.style_title {
  padding: 8px 24px 3px;
  font-size: 15px !important;
  font-family: SYHT-Bold !important;
  font-weight: bold !important;
  color: #fff;
}

.tagStyle {
  width: 5px;
  height: 18px;
  background-color: #ffdf99;
  display: inline-block;
  border-radius: 5px;
  margin-right: 10px;
}

.style_title2 {
  padding: 8px 24px 3px;
  font-size: 15px !important;
  font-family: SYHT-Bold !important;
  font-weight: bold !important;
  color: #fff;
}

.flexR {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.flexColumn {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.flexColumnL {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: self-start;
  background-color: #0000006b;
  border-radius: 4px;
  padding: 10px;
}

.flex_Column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.flexC {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flexCC {
  display: flex;
  justify-content: center;
  align-items: center;
}

.CH_FontSty {
  font-weight: 600;
  line-height: 24px;
  font-size: 16px;
}

.CH_FontSty2 {
  font-weight: bold;
}

.FCC {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.FC {
  display: flex;
  align-items: center;
}

.el-submenu .el-menu-item {
  height: 50px;
  line-height: 50px;
  min-width: 180px;
  padding: 0 !important;
}

.el-submenu .el-menu {
  background: #066fb1 !important;
}

.el-menu-item {

  // padding: 0 !important;
  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #fff;
    position: absolute;
    top: 21px;
    left: 35px;
  }
}

// .el-menu--inline {
//   .el-submenu__title {
//     color: red !important;
//   }
// }

.el-menu-item {
  img {
    content: url("./assets/img/6.0/未选中.png");
  }
}

// 侧边栏样式开始
.el-menu-item.is-active {
  img {
    content: url("./assets/img/6.0/选中.png");
  }
}

// 全局饿了么tree宽度自适应
.el-tree {
  min-width: 100%;
  display: inline-block;
}

.flexL {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.flexWrap {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px 45px;
}

span {
  outline: none;
}

.testAnimation-enter,
.testAnimation-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

#drag {
  cursor: pointer;
  // transition: all 0.5s ease;
  position: absolute;
  left: 20px;
  top: 20px;
  width: 200px;
  background-color: rgba(0, 0, 0, 0);

  .Yuan {
    transition: all 0.5s ease;
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    box-shadow: 0 0 10px 2px rgba(146, 146, 146, 0.493);
    background-color: rgb(255, 255, 255);
    top: -10px;
    left: -10px;
    z-index: 999;

    span {
      // transition: all 0.5s ease;
      margin: 14px auto;
      display: block;
      width: 36%;
      height: 2px;
      border-radius: 20px;
      background-color: rgba(94, 94, 94, 0.61);
    }

    span:nth-child(1) {
      transform: rotate(45deg);
    }

    span:nth-child(2) {
      transform: translateY(-7px) rotate(-45deg);
    }
  }

  .Yuan-title {
    // transition: all 0.5s ease;
    padding: 0 0 10px 0;
    width: 160px;
    max-height: 782px;
    overflow-y: auto;
    background-color: #ffffffcb;
    border-radius: 5px;
    position: relative;
    top: 5px;
    left: 5px;
    z-index: 99;
    box-shadow: 0 0 10px 2px rgba(134, 134, 134, 0.39);

    .Yuan-btn {
      width: 80%;
      height: 32px;
      margin: 0 auto 15px;

      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.modelInfo {
  overflow: hidden;
  // width: 100px;
}

.zIndex {
  position: relative;
  z-index: 1;
}

.w100 {
  width: 100px;
  text-align: right;
}

.textEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.btns {
  background: url("assets/img/A三期/未选中.png");
  width: 110px;
  height: 34px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-top: 26px;

  p {
    overflow: hidden;
    font-size: 13px;
    font-weight: bold;
    margin-top: -18px;
  }
}

.btnss {
  background: url("assets/img/A三期/选中.png");
  width: 110px;
  height: 34px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-top: 26px;

  p {
    overflow: hidden;
    font-size: 13px;
    font-weight: bold;
    margin-top: -18px;
  }
}

.el-submenu__title i {
  color: #ffffff !important;
}

// 隐藏滚动条
.hiddenScroll::-webkit-scrollbar {
  display: none;
}

.flex {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.flexColumn {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content_left {
  position: relative;
  z-index: 1;
}

.viewcubeWrapper {
  display: none !important;
}

.flexBt {
  display: flex;
  justify-content: space-between;
}

.flexSACC {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.flexWPSA {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

//走马灯指示器变成小圆点
.el-carousel__indicator--horizontal .el-carousel__button {
  width: 10px;
  height: 10px;
  background: transparent;
  border: 1px solid #ffffff;
  border-radius: 50%;
  opacity: 0.5;
}

.el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 10px;
  height: 10px;
  background: #40a5fb;
  border-radius: 50%;
  opacity: 1;
}

.fontColor {
  background-image: -webkit-linear-gradient(bottom, #2989df, #fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
}

.fontColorLeft {
  background-image: linear-gradient(to right, #2989df, #fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
}

.fzfs {
  font-family: "fzfs" !important;
}

.SYHT-Bold {
  font-family: "SYHT-Bold" !important;
}


</style>

<style lang="less" scoped>
@font-face {
  font-family: "fzfs";
  src: url("./assets/img/Wisdom/PANGMENZHENGDAOBIAOTITI-1.TTF");
  font-weight: normal;
  font-style: normal;
}

/deep/ .el-submenu .el-menu-item {
  height: 50px;
  line-height: 50px;
  padding: 0 40px !important;
  // background: none !important;
  min-width: 180px;
}

#app {
  width: 100%;
  height: 100%;
  user-select: none;
}

/deep/ .el-dialog__body .el-row {
  padding: 20px;
}

/deep/ .el-dialog__body {
  padding: 5px 10px 10px 10px !important;
}

/deep/ .el-dialog__header {
  padding: 10px !important;

  .el-dialog__headerbtn {
    top: 10px !important;
    right: 10px !important;

    .el-dialog__close {

      font-weight: bold !important;
    }
  }
}


// 全局
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}

// 应用导航
div#WorkPlaneRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #0092d9;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#WorkPlaneRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#WorkPlaneRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#WorkPlaneRemenu ul li:hover {
  background: #eee;
  color: #000000;
}

#WorkPlaneTree {
  height: 500px;
}

.zTreeDiv {
  overflow: auto;
}

.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}

// 模型菜单
/deep/ .ztree li span.button.pIcon01_ico_open,
/deep/ .ztree li span.button.button.pIcon01_ico_close,
/deep/ .ztree li span.button.pIcon01_ico_docu {
  margin-right: 2px;
  background: url("./assets/img/singleMode.png") no-repeat scroll 3px 1px transparent;
  vertical-align: top;
  background-size: 80%;
  *vertical-align: middle;
}

/deep/ .ztree li span.button.pIcon02_ico_open,
/deep/ .ztree li span.button.button.pIcon02_ico_close,
/deep/ .ztree li span.button.pIcon02_ico_docu {
  margin-right: 2px;
  background: url("./assets/img/dieAssembly.png") no-repeat scroll 0 0 transparent;
  vertical-align: top;
  background-size: cover;
  *vertical-align: middle;
}

/deep/ .ztree li span.button.pIcon03_ico_open,
/deep/ .ztree li span.button.button.pIcon03_ico_close,
/deep/ .ztree li span.button.pIcon03_ico_docu {
  margin-right: 2px;
  background: url("./assets/img/Boxselection.png") no-repeat scroll 0 0 transparent;
  vertical-align: top;
  background-size: cover;
  *vertical-align: middle;
}

/deep/ .ztree li span.button.pIcon04_ico_open,
/deep/ .ztree li span.button.button.pIcon04_ico_close,
/deep/ .ztree li span.button.pIcon04_ico_docu {
  margin-right: 2px;
  background: url("./assets/img/file.png") no-repeat scroll 3px 1px transparent;
  vertical-align: top;
  background-size: 82%;
  *vertical-align: middle;
}
/deep/.fzfsTitle{
  margin: 0!important;
}
</style>
